(() => {
  const init = (root) => {
    if (root.dataset.aeyaCarouselReady) return;
    root.dataset.aeyaCarouselReady = 'true';

    const track = root.querySelector('[data-track]');
    const prev = root.querySelector('[data-dir="prev"]');
    const next = root.querySelector('[data-dir="next"]');
    if (!track || !prev || !next) return;

    const page = () => {
      const first = track.querySelector('.aeya-carousel__item');
      if (!first) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
      return first.getBoundingClientRect().width + gap;
    };

    const updateState = () => {
      const max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max;
    };

    prev.addEventListener('click', () => track.scrollBy({ left: -page(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: page(), behavior: 'smooth' }));
    track.addEventListener('scroll', updateState, { passive: true });
    window.addEventListener('resize', updateState);
    updateState();
  };

  const boot = () => document.querySelectorAll('.aeya-carousel').forEach(init);

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('.aeya-carousel');
    if (root) init(root);
  });
})();
